import axiosInstance from '../config/axios.js';

const API_BASE = '/inventory';

const inventoryService = {
  // Get all inventory items with optional filters and pagination
  getAll: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get inventory item by ID
  getById: async (inventoryId) => {
    const response = await axiosInstance.get(`${API_BASE}/${inventoryId}`);
    return response.data;
  },

  // Create new inventory item
  create: async (itemData, itemImage = null, invoiceAttachment = null) => {
    const formData = new FormData();
    
    // Append all item data
    Object.keys(itemData).forEach(key => {
      if (itemData[key] !== null && itemData[key] !== undefined && itemData[key] !== '') {
        formData.append(key, itemData[key]);
      }
    });

    // Append files if provided
    if (itemImage) {
      formData.append('item_image', itemImage);
    }
    if (invoiceAttachment) {
      formData.append('invoice_attachment', invoiceAttachment);
    }

    const response = await axiosInstance.post(API_BASE, formData, {
      headers: {
        'Content-Type': undefined,
      },
    });
    return response.data;
  },

  // Update inventory item
  update: async (inventoryId, itemData, itemImage = null, invoiceAttachment = null) => {
    const formData = new FormData();
    
    // Append all item data
    Object.keys(itemData).forEach(key => {
      if (itemData[key] !== null && itemData[key] !== undefined && itemData[key] !== '') {
        formData.append(key, itemData[key]);
      }
    });

    // Append files if provided
    if (itemImage) {
      formData.append('item_image', itemImage);
    }
    if (invoiceAttachment) {
      formData.append('invoice_attachment', invoiceAttachment);
    }

    const response = await axiosInstance.put(`${API_BASE}/${inventoryId}`, formData, {
      headers: {
        'Content-Type': undefined,
      },
    });
    return response.data;
  },

  // Delete inventory item
  delete: async (inventoryId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${inventoryId}`);
    return response.data;
  },

  // Adjust stock (add or reduce)
  adjustStock: async (inventoryId, adjustmentType, quantity) => {
    const response = await axiosInstance.post(`${API_BASE}/${inventoryId}/adjust-stock`, {
      adjustment_type: adjustmentType,
      quantity: quantity
    });
    return response.data;
  },

  // Get out of stock items
  getOutOfStock: async () => {
    const response = await axiosInstance.get(`${API_BASE}/out-of-stock`);
    return response.data;
  },

  // Get items by category
  getByCategory: async (category) => {
    const response = await axiosInstance.get(`${API_BASE}/category/${category}`);
    return response.data;
  },

  // Get item image URL
  getItemImage: (inventoryId) => {
    return `${axiosInstance.defaults.baseURL}${API_BASE}/${inventoryId}/item-image`;
  },

  // Get all categories
  getCategories: () => {
    return [
      { value: 'Vehicle Parts', label: 'Vehicle Parts' },
      { value: 'Packaging Materials', label: 'Packaging Materials' },
      { value: 'Fuel & Lubricants', label: 'Fuel & Lubricants' },
      { value: 'Office Supplies', label: 'Office Supplies' },
      { value: 'Safety Equipment', label: 'Safety Equipment' },
      { value: 'Tools & Equipment', label: 'Tools & Equipment' },
      { value: 'Electronics', label: 'Electronics' },
      { value: 'Furniture', label: 'Furniture' },
      { value: 'Cleaning Supplies', label: 'Cleaning Supplies' },
      { value: 'Maintenance Supplies', label: 'Maintenance Supplies' },
      { value: 'Shipping Supplies', label: 'Shipping Supplies' },
      { value: 'Uniforms & Apparel', label: 'Uniforms & Apparel' },
      { value: 'IT Equipment', label: 'IT Equipment' },
      { value: 'Spare Parts', label: 'Spare Parts' },
      { value: 'Consumables', label: 'Consumables' },
      { value: 'Other', label: 'Other' }
    ];
  },

  // Get all statuses
  getStatuses: () => {
    return [
      { value: 'In Stock', label: 'In Stock' },
      { value: 'Low Stock', label: 'Low Stock' },
      { value: 'Out of Stock', label: 'Out of Stock' },
      { value: 'On Order', label: 'On Order' },
      { value: 'Reserved', label: 'Reserved' },
      { value: 'Damaged', label: 'Damaged' },
      { value: 'Expired', label: 'Expired' },
      { value: 'Discontinued', label: 'Discontinued' },
      { value: 'Under Maintenance', label: 'Under Maintenance' }
    ];
  }
};

export default inventoryService;